import React from "react";
import { dateFormator, mapTableRows } from "../../../../utils";
import {
  Backdrop,
  Button,
  DualIcon,
  FormFieldSet,
  LogoLoader,
  NewTableAdv,
  showToast,
  SmartTooltip,
  TableAdv,
} from "../../../../components";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchClientSubmissionsStart } from "../../../../redux/slices/bdmjobs/bdmjobsSlice";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import {
  fetchAllNotes,
  updateSubmissionStatus,
} from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import ApplicantsDetailsDrawer from "../../Applicants/Applicant/Modal/ApplicantsDetailsDrawer";
import AddNoteModal from "../../ConfirmedStart/Confirmed/modals/AddNoteModal";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { formatWords2 } from "../../../../utils/stringUtils";
const statusOptions = [
  { label: "Submitted to Client", value: 10 },
  { label: "Submitted To Vendor", value: 11 },
  { label: "Shortlisted for Interview", value: 12 },
  { label: "Interview Confirmation", value: 13 },
  { label: "Interview Scheduled", value: 14 },
  { label: "L1 Interview Scheduled", value: 15 },
  { label: "L2 Interview Scheduled", value: 16 },
  { label: "L3 Interview Scheduled", value: 17 },
  { label: "L1 Interview Selected", value: 18 },
  { label: "L2 Interview Selected", value: 19 },
  { label: "L3 Interview Selected", value: 20 },
  { label: "L1 Interview Rejected", value: 21 },
  { label: "L2 Interview Rejected", value: 22 },
  { label: "L3 Interview Rejected", value: 23 },
  { label: "L1 Interview Re-Scheduled", value: 24 },
  { label: "L2 Interview Re-Scheduled", value: 25 },
  { label: "L3 Interview Re-Scheduled", value: 26 },
  { label: "L1 Interview Feedback Pending", value: 27 },
  { label: "L2 Interview Feedback Pending", value: 28 },
  { label: "L3 Interview Feedback Pending", value: 29 },
  { label: "Rejected By Client", value: 30 },
  { label: "Selected but no response from the client", value: 31 },
  { label: "Rejected after Client Selection", value: 32 },
  { label: "Submitted to End Client", value: 33 },
  { label: "Vendor Interview", value: 34 },
  { label: "Vendor Interview Reject", value: 35 },
  { label: "Client Interview", value: 36 },
  { label: "Client Interview Select", value: 37 },
  { label: "Client Interview Reject", value: 38 },
  { label: "Client Interview Completed", value: 39 },
  { label: "End Client Interview", value: 40 },
  { label: "End Client Interview Completed", value: 41 },
  { label: "Selected By Vendor", value: 42 },
  { label: "Selected By Client", value: 43 },
  { label: "Selected By End Client", value: 44 },
  { label: "Rejected By Vendor", value: 45 },
  { label: "Rejected by End Client", value: 46 },
  { label: "Disqualified By Vendor", value: 47 },
  { label: "Disqualified By Client", value: 48 },
  { label: "Disqualified by End Client", value: 49 },
  { label: "Hold By Vendor", value: 50 },
  { label: "Hold By Client", value: 51 },
  { label: "Hold by End Client", value: 52 },
  { label: "Drop", value: 53 },
  { label: "Position on Hold", value: 54 },
  { label: "PW Interview Proposed By Buyer", value: 55 },
  { label: "PW Interview Proposed By Supplier", value: 56 },
  { label: "PW Interview Failed", value: 57 },
  { label: "PW Interview Cancelled", value: 58 },
  { label: "PW Interview Success", value: 59 },
  { label: "Assignment Contract Sent", value: 60 },
  { label: "Assignment Contract Verified", value: 61 },
  { label: "Assignment Contract Rejected", value: 62 },
  { label: "Confirmed", value: 63 },
  { label: "Position Filled", value: 64 },
  { label: "Backout", value: 65 },
  { label: "Not Joined", value: 66 },
  { label: "BGV Failed", value: 67 },
  { label: "Got Pay Rate Confirmation", value: 68 },
  { label: "Offer Withdrawn", value: 69 },
  { label: "Negotiation", value: 70 },
  { label: "Start", value: 71 },
  { label: "Offer Sent", value: 72 },
  { label: "Offer Accepted", value: 73 },
  { label: "Offer Rejected", value: 74 },
  { label: "Hold with Client", value: 75 },
  { label: "Hold with Vendor", value: 76 },
];

const ClientSubmission = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { value } = useSelector((state) => state.totalCount);
  const clientData = useSelector(
    (state) => state.bdmJobs.clientsubmissions.data,
  );
  const loading = useSelector(
    (state) => state.bdmJobs.clientsubmissions.loading,
  );
  const data = clientData;
  // console.log("Redux data:", data);

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const totalCount = value?.clientSubCount?.data || 0;
  const [detailsDrawer, setDetailsDrawer] = useState(false);
  const [selectedApplicantId, setSelectedApplicantId] = useState(null);
  const [noteModal, setNotesModal] = useState(false);
  const [hoveredNotes, setHoveredNotes] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [statusLoading, setStatusLoading] = useState(false);
  //console.log(clientData)
  const filterData = (clientData || []).find(
    (data) => data?.candidateId?.uiid === selectedApplicantId,
  );
  //console.log(filterData,selectedApplicantId)
  const handleStatusChange = async (option, row) => {
    try {
      setStatusLoading(true);
      const newStatus = option;

      // build payload to push into statusHistory
      const payload = [
        {
          type: "PUSH",
          value: {
            statusHistory: {
              addedBy: user?.data?.uiid,
              addedOn: new Date().toISOString(),
              status: newStatus,
            },
          },
        },
      ];

      const res = await updateSubmissionStatus({
        coll: "Submission",
        uiid: row?.uiid,
        payload,
      });

      if (res?.data) {
        showToast("Status updated successfully", "success");
        const action = {
          coll: "Submission",
          lim: limit,
          pg: page,
          ref: "JobPosting Candidate",
          // fil:{ "submissionStatus": {  "type": "NONE", "value": 2 } },
          // fil: JSON.stringify({
          //   submissionStatus: { type: "NONE", value: 2 },
          // }),
          fil: {
            "statusHistory.status": {
              type: "ARRAY_LAST_TWO_FIELDS_EQ",
              value: [10, 11],
            },
          },
          extret: "uiid firstName",
          ret: "uiid addedBy jobPostId updatedAt statusHistory addedOn",
          incl: [
            "uiid jobInfo.jobCode jobInfo.endClient companyId",
            "uiid firstName lastName jobTitle",
          ],
          sort: JSON.stringify({ addedOn: -1 }),
          onSuccess: (data) => {
            console.log("Fetched submissions:", data);
          },
        };

        dispatch(fetchClientSubmissionsStart(action));
      } else {
        showToast("Failed to update status", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Failed to update status", "error");
    } finally {
      setStatusLoading(false);
    }
  };

  const getHoveredNotes = async (notes) => {
    setHoveredNotes([]);

    try {
      const res = await fetchAllNotes({
        coll: "Note",
        pg: 1,
        lim: 2,
        ret: "uiid note addedBy addedOn",
        fil: { uiid: { type: "IN", value: notes } },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
      });

      if (res?.data) {
        setHoveredNotes(res.data.data || []);
      } else {
        setHoveredNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
    }
  };

  const columns = [
    {
      key: "icons",
      label: "",
      width: "min-w-[150px]! max-w-[250px]!",
      render: (row) => (
        <div className="flex items-center gap-2">
          <Button
            type="icon"
            color="black"
            icon={"visibility"}
            size="sm"
            variant="text"
            // size="sm"
            // icon="article"
            // badgeIcon={"visibility"}
            // iconColor="info"
            // dotPosition="bottom-right"
            onClick={() => {
              setSelectedApplicantId(row?.candidateUiid);
              setDetailsDrawer(true);
            }}
          />
          {row?.notes?.length > 0 && (
            <div
              onMouseEnter={() =>
                row?.notes?.length > 0 ? getHoveredNotes(row?.notes) : {}
              }
              onMouseLeave={() => setHoveredNotes([])}
            >
              <DualIcon
                size="sm"
                icon="chat"
                badgeIconColor={
                  row?.notes?.length > 0 ? "bg-success" : "bg-dark"
                }
                onClick={() => {
                  setSelectedApplicantId(row?.candidateUiid);
                  setNotesModal(true);
                }}
                tooltipDescription={
                  Array.isArray(hoveredNotes) && hoveredNotes?.length > 0 ? (
                    <div className="flex flex-col gap-2">
                      {hoveredNotes.map((hoveredNote, i) => (
                        <p key={i}>
                          "{hoveredNote?.note || ""}" by{" "}
                          {formatWords2(hoveredNote?.addedBy?.firstName) || ""}{" "}
                          on{" "}
                          {dateFormator(
                            convertFromUTC(hoveredNote?.addedOn),
                            "datetime-ampm",
                          ) || ""}
                        </p>
                      ))}
                    </div>
                  ) : (
                    "Add note"
                  )
                }
                tooltipDelay={500}
                showTooltip={true}
              />
            </div>
          )}
        </div>
      ),
    },
    {
      key: "candidateName",
      label: "Candidate Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row.candidateName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.candidateName}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "accountName",
      label: "Account Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row.accountName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.accountName}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[230px]! max-w-[270px]!",
      render: (row) => (
        <SmartTooltip
          description={row.jobTitle}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.jobTitle}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "jobId",
      label: "Job ID",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row.jobId}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="text-info-500 line-clamp-1">{row.jobId}</div>
        </SmartTooltip>
      ),
    },
    // {
    //   key: "submissionId",
    //   label: "Submission ID",
    //   render: (row) => (
    //     <div className="text-success-500">{row.submissionId}</div>
    //   ),
    // },
    // {
    //   key: "experience",
    //   label: "Experience (in years)",
    // },
    // {
    //   key: "stateAndCity",
    //   label: "State, City",
    // },
    {
      key: "submittedBy",
      label: "Job Created By",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "jobCreatedOn",
      label: "Job Created On",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "jobStatus",
      label: "Candidate Status",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <div className="w-[180px] min-w-[160px]">
          <FormFieldSet
            type="select"
            noTitle
            size="sm"
            // value="Submitted"
            value={
              row?.statusHistory?.[row?.statusHistory?.length - 1]?.status || ""
            }
            // options={[
            //   { label: "Submitted", value: "submitted" },
            //   { label: "Awaiting Screening", value: "awaitingScreening" },
            //   { label: "Interview Scheduled", value: "interviewScheduled" },
            //   {
            //     label: "Interview Feedback Awaiting",
            //     value: "interviewFeedbackAwaiting",
            //   },
            //   { label: "On Hold", value: "onHold" },
            // ]}
            options={statusOptions}
            onChange={(option) => handleStatusChange(option, row)}
            showSearch
          />
        </div>
      ),
    },
    // {
    //   key: "primarySkills",
    //   label: "Primary Skills",
    //   render: (row) => (
    //     <div className="flex gap-1">
    //       {row.primarySkills.map((skill) => (
    //         <p>{`${skill}, `}</p>
    //       ))}
    //     </div>
    //   ),
    // },
  ];

  const mappedRows = React.useMemo(() => {
    return mapTableRows(
      (data || []).map((item) => ({
        // jobId: item?.jobPostId?.jobCode || "-",
        jobId: item?.jobPostId?.jobInfo?.jobCode || "-",
        submissionId: item?.uiid || "-",
        candidateName: `${formatWords2(item?.candidateId?.firstName || "")} ${formatWords2(item?.candidateId?.lastName || "")
          }`.trim(),
        experience: item?.candidateId?.exp
          ? `${item.candidateId.exp.year || 0}y ${
              item.candidateId.exp.mon || 0
            }m`
          : "0y",
        stateAndCity: item?.candidateId?.location
          ? `${formatWords2(item.candidateId.location.state || "")}, ${formatWords2(item.candidateId.location.city || "")
          }`
          : "-",
        jobTitle: formatWords2(item?.candidateId?.jobTitle || "-"),
        submittedBy: formatWords2(item?.addedBy?.firstName || "-"),
        // submittedOn: item?.addedOn
        //   ? new Date(item.addedOn).toLocaleDateString()
        //   : "-",
        jobCreatedOn: item?.addedOn
          ? new Date(convertFromUTC(item.addedOn)).toLocaleDateString("en-GB")
          : "-",
        jobStatus: item?.submissionStatus || "-",
        accountName: formatWords2(item?.jobPostId?.jobInfo?.endClient || item?.jobPostId?.companyId?.name || item?.jobPostId?.jobId?.companyId?.name || "—"),
        primarySkills: item?.jobPostId?.skills?.primarySkills || [],
        statusHistory: item?.statusHistory || [],
        uiid: item?.uiid || null,
        candidateUiid: item?.candidateId?.uiid,
        notes: item?.candidateId?.notes || [],
      })),
      columns,
    );
  }, [data, columns]);

  const fetchClientSubmissions = () => {
    const action = {
      coll: "Submission",
      lim: limit,
      pg: page,
      ref: "JobPosting Candidate",
      // fil:{ "submissionStatus": {  "type": "NONE", "value": 2 } },
      // fil: JSON.stringify({
      //   submissionStatus: { type: "NONE", value: 2 },
      // }),
      fil: {
        "statusHistory.status": {
          type: "ARRAY_LAST_TWO_FIELDS_EQ",
          value: [10, 11],
        },
      },
      extret: "uiid firstName",
      ret: "uiid addedBy jobPostId updatedAt statusHistory addedOn",
      incl: [
        "uiid jobInfo.jobCode jobInfo.endClient companyId",
        "uiid firstName lastName jobTitle notes",
      ],
      sort: JSON.stringify({ addedOn: -1 }),
      onSuccess: (data) => {
        console.log("Fetched submissions:", data);
      },
    };

    dispatch(fetchClientSubmissionsStart(action));
  };

  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "submissions",
        coll: "Submission",
        tname: "clientSubCount",
        filters: {
          "statusHistory.status": {
            type: "ARRAY_LAST_TWO_FIELDS_EQ",
            value: [10, 11],
          },
        },
        app: "ats",
      }),
    );
    fetchClientSubmissions();
  }, [dispatch, page, limit]);

  return (
    <div className="flex flex-col mt-5 flex-1 overflow-hidden">
      <div className="flex-1 overflow-hidden flex gap-4 p-0.5">
        <div className="flex-1 overflow-auto">
          {/* <NewTableAdv
            showCheckbox
            rows={mappedRows}
            columns={columns}
            tdClassName="!py-2"
            toolbarRight={{
              search: true,
              filter: true,
              download: false,
            }}
          /> */}
          <TableAdv
            showCheckbox
            rows={mappedRows}
            columns={columns}
            onSelectionChange={setSelectedRows}
            defaultSelectedRows={selectedRows}
            tableId={"BDM_clientsubmission"}
            serverPagination={true}
            totalCount={totalCount}
            page={page}
            limit={limit}
            onPaginationChange={setPage}
            onLimitChange={handleLimitChange}
            toolbarRight={{
             // search: true,
              filter: true,
              download: false,
            }}
          />
        </div>
      </div>
      <ApplicantsDetailsDrawer
        isOpen={detailsDrawer}
        onClose={() => setDetailsDrawer(false)}
        applicantId={selectedApplicantId}
      />
      <AddNoteModal
        isOpen={noteModal}
        onClose={() => setNotesModal(false)}
        data={filterData}
      />
      <Backdrop isOpen={loading || statusLoading} zIndex={51}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default ClientSubmission;
